import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetAddressInfo = () => {
  const [loading, setLoading] = useState(true);
  const [addressInfo, setAddressInfo] = useState(null);
  const [pageRef, setpageRef] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const getAddressInfo = ({ addressGuid } = {}) => {
    setLoading(true);

    axiosClient
      .get(`InventoryAddress/GetInfo?GUID=${addressGuid}&full=true`)
      .then(res => {
        if (res.status === 200) {
          setpageRef(res.data.value);
          setAddressInfo(prev => {
            return res.data?.value;
          });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getAddressInfo, loading, addressInfo, pageRef];
};

export default useGetAddressInfo;
